import React, { Suspense } from "react";
import { Router, Route, Redirect } from "react-router-dom";
import history from "./common/history";

import SvgSprite from "./utility/SvgSpriteLoader";
//App routes
import { privateRoutes, publicRoutes } from "./routes";

import "./ant.less";
import { isUserLoggedIn, isOpenPath } from "./common/common-methods";
import { componentPaths } from "./constants/path-constants";

class App extends React.Component {
  render() {
    return (
      <React.Fragment>
        <SvgSprite url={"/assets/images/svg/svg-sprite.svg"} />
        <Router
          history={history}
          basename={process.env.REACT_APP_BASENAME || ""}
        >
          {publicRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={(props) => {
                  return (
                    <route.layout {...props}>
                      <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>}>
                        <route.component {...props} />
                      </Suspense>
                    </route.layout>
                  );
                }}
              />
            );
          })}
          {privateRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={(props) => {
                  return isUserLoggedIn() || isOpenPath(route.path) ? (
                    <route.layout {...props}>
                      <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>}>
                        <route.component {...props} />
                      </Suspense>
                    </route.layout>
                  ) : (
                    <Redirect
                      to={{
                        pathname: componentPaths.login,
                        state: {
                          NAVIGATION_REFERENCE:
                            componentPaths.orderdetails() === route.path
                              ? ""
                              : route.path,
                        },
                      }}
                    />
                  );
                }}
              />
            );
          })}
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
